import { rejoinCardImages as e, rejoinImagePath as t } from "./rejoinCardImages.mjs";
//#region src/properties/rejoinHomeRows.ts
var n = (n) => ({
	...n,
	rows: n.rows.map((r) => ({
		...r,
		seeAll: r.seeAll && {
			...r.seeAll,
			previewImages: r.seeAll.previewImages?.map((e) => t(e, n.imageBase))
		},
		cards: r.cards.map((t) => e(t, n.imageBase))
	}))
});
//#endregion
export { n as withAbsoluteHomeRows };
